import React from "react";
import { BsGithub } from "react-icons/bs";
import { GrCode } from "react-icons/gr";
import { SiLeetcode } from "react-icons/si";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a href="https://github.com/Naman-Gupta1234"><BsGithub/></a>
      </div>
      <div>
        <a href="https://www.codingninjas.com/studio/profile/naman_gupta"><GrCode /></a>
      </div>
      <div>
        <SiLeetcode />
      </div>
    </div>
  );
};

export default SocialMedia;
